import colorUtils from 'react-color/lib/helpers/color';
export var getColor = function getColor(colorString) {
  return colorUtils.toState(colorString);
};
export var getHexColor = function getHexColor(colorString) {
  return getColor(colorString).hex;
};
export var getRgbString = function getRgbString(rgb) {
  return "rgb(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ")");
};
export default {
  getColor: getColor,
  getHexColor: getHexColor,
  getRgbString: getRgbString
};